/* eslint-disable @typescript-eslint/no-explicit-any */
import { MoreOutlined } from '@ant-design/icons'
import {
  IActionEvent,
  IEvent,
  RegisterTeamActivityStatus,
} from 'app/api/event/model'
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BasePopover } from 'app/components/common/BasePopover'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import {
  ILocation,
  ITeam,
} from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { isEqual } from 'lodash'
import { ModalApproveTeam } from '../ModalApprove'
import { ModalRejectTeam } from '../ModalReject'
import { ModalApproveManyTeam } from '../ModalApproveMany'
import { BaseRow } from 'app/components/common/BaseRow'

interface IData {
  key?: number
  activity?: IActionEvent
  reason?: string
  event?: IEvent
  name?: string
  limit?: number
  description?: string

  tums?: ITradeUnionMember[]

  id?: number

  create_by?: ITradeUnionMember
}

export const TeamRegisteredByStatusLayout = ({
  status,
  locations,
  data,
  isLoading,
}: {
  status: RegisterTeamActivityStatus
  listTeam?: ITeam[]
  locations?: ILocation[]
  data: any[]
  isLoading?: boolean
}) => {
  return (
    <BaseSpace>
      {isEqual(status, RegisterTeamActivityStatus.WAITING) ? (
        <BaseRow justify={'end'} align={'middle'}>
          <ModalApproveManyTeam teams={data} locations={locations} />
        </BaseRow>
      ) : null}
      
      <BaseTableManagement
        dataSource={data}
        columns={[
          convertColumnTable<IData>({
            title: 'STT',
            key: 'key',
            classNameWidthColumnOverwrite: 'number-column',
            fixed: 'left',
            render: value => {
              return (
                <BaseText children={value} fontWeight="medium" opacity="0.7" />
              )
            },
          }),

          convertColumnTable<IData>({
            title: 'Tên đội',
            key: 'name',
            render: (_, record) => {
              return (
                <BaseText children={record?.name ?? ''} fontWeight="semibold" />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Mô tả đội',
            key: 'description',
            render: (_, record) => {
              return (
                <BaseText
                  children={record?.description ?? ''}
                  fontWeight="medium"
                  opacity="0.7"
                />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Thành viên',
            key: 'tums',
            classNameWidthColumnOverwrite: 'big-column',
            render: (_, record) => {
              return (
                <BaseSpace size={8}>
                  {record?.tums?.map(item => {
                    return (
                      <BaseText
                        children={item?.fullName}
                        fontWeight="semibold"
                      />
                    )
                  })}
                </BaseSpace>
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Người tạo',
            key: 'create_by',
            classNameWidthColumnOverwrite: 'very-big-column',
            render: (_, record) => {
              return (
                <BaseSpace size={4}>
                  <BaseText
                    children={record?.create_by?.fullName}
                    fontWeight="semibold"
                  />
                  <BaseText children={`Email: ${record?.create_by?.email}`} />

                  <BaseText
                    children={`Mã quản lý: ${record?.create_by?.mql}`}
                  />
                </BaseSpace>
              )
            },
          }),

          ...(isEqual(status, RegisterTeamActivityStatus.WAITING)
            ? [
                convertColumnTable<IData>({
                  title: '',
                  key: 'key',
                  width: '10%',
                  fixed: 'right',
                  classNameWidthColumnOverwrite: 'number-column',
                  render: (_, record) => {
                    return (
                      <BasePopover
                        content={
                          <BaseSpace>
                            <ModalApproveTeam
                              id={record?.id}
                              locations={locations}
                            />
                            <ModalRejectTeam id={record?.id} />
                          </BaseSpace>
                        }
                        trigger={'click'}
                      >
                        <BaseButton
                          type="text"
                          icon={<MoreOutlined rev={undefined} />}
                        />
                      </BasePopover>
                    )
                  },
                }),
              ]
            : []),

          ...(isEqual(status, RegisterTeamActivityStatus.REJECTED)
            ? [
                convertColumnTable<IData>({
                  key: 'key',
                  title: 'Lý do từ chối',
                  render: (_, record) => {
                    return (
                      <BaseText
                        children={record?.reason ?? ''}
                        colorText="statesRedColor"
                        fontWeight="medium"
                      />
                    )
                  },
                }),
              ]
            : []),
        ]}
        loading={isLoading}
        scroll={{ x: true }}
      />
    </BaseSpace>
  )
}
